import useSWR from "swr";
import { PricesResponse } from "@/pages/api/prices";
import { createPricingList, Pricing } from "@/components/landing/Pricing";
import { MarketingShell } from "@/components/landing/MarketingShell";
import { Comparison } from "@/components/landing/Comparison";
import { SeoHead } from "@/components/useSeo";

const Page = () => {
  const { data: prices } = useSWR<PricesResponse[]>("/api/prices");

  if (!prices) {
    return null;
  }

  return (
    <MarketingShell>
      <SeoHead path="pricing" />

      <div className="flex flex-col gap-20 md:gap-30 pt-20 mb-20">
        <Pricing pricing={createPricingList(prices)} />
        <Comparison />
      </div>
    </MarketingShell>
  );
};

export default Page;
